const stories = [
    {
        image: 'stories/wild-planet-product-sampling-case-study.png',
        imageAlt: 'Wild Planet product sampling case study',
        description: '<span class="font f-w-800 f-s-24 l-h-32" style="color: #141414;">Wild Planet reaching only new-to-brand while collecting <span style="color: #0E47C0;">100% of emails</span> through a scalable approach.</span>',
        uri: '/',
        alt: 'Wild Planet product sampling case study',
    },
    {
        image: 'stories/hartz-product-sampling-programs-case-study.png',
        imageAlt: 'Hartz product sampling programs case study',
        description: '<span class="font f-w-800 f-s-24 l-h-32" style="color: #141414;">Hartz expanded the customer base to include Millennials and Gen Zs, achieving an impressive ROI of <span style="color: #009B8E;">over 5x</span> through direct sales.</span>',
        uri: '/',
        alt: 'Hartz product sampling programs case study',
    },
    {
        image: 'stories/swanson-product-sampling-services-case-study.png',
        imageAlt: 'Swanson product sampling services case study',
        description: '<span class="font f-w-800 f-s-24 l-h-32" style="color: #141414;">Swanson generated exceptional product reviews and testimonials for <span style="color: #F78834;">30+ new</span> products quickly.</span>',
        uri: '/',
        alt: 'Swanson product sampling services case study',
    },
];

export default stories;
